"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/portal_common.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalTicketBonusMedia = exports.PortalEvent = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.event.v1.PortalEvent
 */
class PortalEvent extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * イベントバナー
         *
         * @generated from field: string event_banner = 3;
         */
        this.eventBanner = "";
        /**
         * イベント詳細
         *
         * @generated from field: string description = 4;
         */
        this.description = "";
        /**
         * ページの公開日時
         *
         * @generated from field: int64 open = 5;
         */
        this.open = protobuf_1.protoInt64.zero;
        /**
         * 開場日時
         *
         * @generated from field: int64 part_open_time = 6;
         */
        this.partOpenTime = protobuf_1.protoInt64.zero;
        /**
         * 配信開始日時
         *
         * @generated from field: int64 part_start_time = 7;
         */
        this.partStartTime = protobuf_1.protoInt64.zero;
        /**
         * 配信終了日時
         *
         * @generated from field: int64 event_end_time = 8;
         */
        this.eventEndTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEvent, a, b);
    }
}
exports.PortalEvent = PortalEvent;
PortalEvent.runtime = protobuf_1.proto3;
PortalEvent.typeName = "spwn.event.v1.PortalEvent";
PortalEvent.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "open", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "part_open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "part_start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "event_end_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.PortalTicketBonusMedia
 */
class PortalTicketBonusMedia extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 2;
         */
        this.mediaId = "";
        /**
         * アップロードされたファイルの名前
         *
         * @generated from field: string filename = 3;
         */
        this.filename = "";
        /**
         * 特典名
         *
         * @generated from field: string bonus_name = 4;
         */
        this.bonusName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalTicketBonusMedia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalTicketBonusMedia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalTicketBonusMedia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalTicketBonusMedia, a, b);
    }
}
exports.PortalTicketBonusMedia = PortalTicketBonusMedia;
PortalTicketBonusMedia.runtime = protobuf_1.proto3;
PortalTicketBonusMedia.typeName = "spwn.event.v1.PortalTicketBonusMedia";
PortalTicketBonusMedia.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bonus_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "release_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
//# sourceMappingURL=portal_common_pb.js.map